import { Card, Input, SettingsLayout, Switch } from "@clintonelec/react-storybook";
import ActionButtons from "Components/ConfigLayout/ActionButtons";
import { selectUpnp, setUpnpAction } from "Data/Redux/Slices/Settings/Network/Upnp";
import { useAppDispatch, useAppSelector } from "Data/Redux/Store";
import { produce } from "immer";
import { type FormEvent, type SubmitEvent as ReactSubmitEvent, type ChangeEvent, memo, useState } from "react";

type UpnpForm = {
	friendlyName: HTMLFormElement;
} & HTMLFormElement;

function UpnpSettings() {
	const upnpFromSlice = useAppSelector(selectUpnp);
	const [ localUpnp, setLocalUpnp ] = useState(upnpFromSlice);
	const dispatch = useAppDispatch();
	const setUpnp = () => dispatch(setUpnpAction(localUpnp));

	const handleCancel = (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault();

		setLocalUpnp(upnpFromSlice);
	};

	const handleSubmit = (event: ReactSubmitEvent<HTMLFormElement>) => {
		event.preventDefault();

		setUpnp();
	};

	const handleUpnpEnable = (value: boolean) => {
		const newUpnpState = produce(localUpnp, draft => {
			draft.upnp = value;
		});

		setLocalUpnp(newUpnpState);
	};

	const handleFormChange = (event: ChangeEvent<UpnpForm>) => {
		event.preventDefault();

		const { friendlyName: { value } } = event.currentTarget;
		const newUpnpState = produce(localUpnp, draft => {
			draft.friendlyName = value;
		});

		setLocalUpnp(newUpnpState);
	};

	return (
		<SettingsLayout.Form
			className="upnp-settings"
			onChange={ handleFormChange }
			onReset={ handleCancel }
			onSubmit={ handleSubmit }
		>
			<SettingsLayout.ScrollableContainer>
				<Card size="medium" title="UPnP">
					<div className="form-row">
						<span>UPnP</span>
						<div className="form-switch-wrapper">
							<Switch
								checked={ localUpnp.upnp }
								onChange={ handleUpnpEnable }
							/>
						</div>
					</div>
					<div className="form-row">
						<span>Friendly Name</span>
						<Input
							disabled={ !localUpnp.upnp }
							name="friendlyName"
							wrapClassName="form-input"
							value={ localUpnp.friendlyName }
						/>
					</div>
				</Card>
			</SettingsLayout.ScrollableContainer>
			<ActionButtons disabled={ localUpnp === upnpFromSlice } />
		</SettingsLayout.Form>
	);
}

export default memo(UpnpSettings);
